import React from "react";
import api from "../../api/requests";
import {tempdata} from "../../api/tempdata";

const initialData = {
  deleteModalOpen: false,
  acceptModalOpen: false,
  declineModalOpen: false,
  restoreModalOpen: false,
  isAcceptingRequest: false,
  isDecliningRequest: false,
  isUpdatingRequest: false,
  isRestoringRequest: false,
  requestInfo: null,
  deletedRequest: null,
  updatedRequest: null,
  acceptedRequest: null,
  declinedRequest: null,
  restoredRequest: null,
  isEdited: true
};

export default function useRequestView() {
  const [requestData, setRequestData_] = React.useState(initialData);

  const setRequestData = newData => {
    const newRequestData = {
      ...requestData,
      ...newData
    };

    setRequestData_(newRequestData);
  };

  function updateRequest(id, data) {
    setRequestData({ isUpdatingRequest: true });

    const formattedData = {
      ...data,
      specialities: data.specialities.map(({ id }) => id),
      worldSkills: data.worldSkills.map(({ id }) => id),
      roles: data.roles.map(({ id }) => id)
    }

    api.updateRequest(id, formattedData).then(({ data }) => {
      setRequestData({ updatedRequest: data, isUpdatingRequest: false });
    });
  }

  function deleteRequest(id) {
    api.deleteRequest(id).then(({ data }) => {
      setRequestData({ deletedRequest: data });
    });
  }

  function acceptRequest(id, comment) {
    setRequestData({ isAcceptingRequest: true });

    const formattedData = {
      id: id,
      type: 'approve',
      text: comment
    };

    api.acceptRequest(formattedData).then(({ data }) => {
      setRequestData({ acceptedRequest: data, isAcceptingRequest: false });
      getRequestInfo(id);
    });
  }

  function declineRequest(id, comment) {
    setRequestData({ isDecliningRequest: true });

    const formattedData = {
      id: id,
      type: 'cancel',
      text: comment
    };

    api.declineRequest(formattedData).then(({ data }) => {
      setRequestData({ declinedRequest: data, isDecliningRequest: false });
      getRequestInfo(id);
    });
  }

  function restoreRequest(id, data) {
    setRequestData({ isRestoringRequest: true });

    const formattedData = {
      id: id,
      type: 'resume'
    };

    api.restoreRequest(formattedData).then(({ data }) => {
      setRequestData({ restoredRequest: data, isRestoringRequest: false });
      getRequestInfo(id);
    });
  }

  function getRequestInfo(id) {
    Promise.all([
      api.getRequestFullInfo(id),
      api.getRequestSpecialities(id),
      api.getRequestWorldSkills(id),
      api.getRequestRoles(id)
    ]).then(([requestInfo, specialities, worldSkills, roles]) =>
      setRequestData({
        deleteModalOpen: false,
        acceptModalOpen: false,
        declineModalOpen: false,
        restoreModalOpen: false,
        requestInfo: {
          data: {
            ...requestInfo.data.data,
            specialities: specialities.data,
            worldSkills: worldSkills.data,
            roles: roles.data
          },
          info: requestInfo.data.info
        }
      })
    );
  }

  return {
    requestData,
    setRequestData,
    updateRequest,
    deleteRequest,
    acceptRequest,
    declineRequest,
    restoreRequest,
    getRequestInfo };
}
